import { useEffect, useState } from 'react'

import { PageHeader } from '../../app/PageHeader'
import copy from '../../demo/fixtures/w5/copy.json'
import { Icon, Tabs } from '../../ui'
import { DiagnosisCards } from './DiagnosisCards'
import { useW5Live } from './live'
import { MetricMonitorCard } from './MetricMonitorCard'
import { NextActions } from './NextActions'
import { TaskMonitorCard } from './TaskMonitorCard'
import { WeeklyReportCards } from './WeeklyReportCards'
import styles from './AnalysisPage.module.css'

type AnalysisTab = 'monitor' | 'report'

function tabFromHash(): AnalysisTab {
  const query = window.location.hash.split('?')[1] ?? ''
  return new URLSearchParams(query).get('tab') === 'report' ? 'report' : 'monitor'
}

export function AnalysisPage() {
  const page = copy.pages.analysis
  const { syncLabel } = useW5Live()
  const [tab, setTab] = useState<AnalysisTab>(tabFromHash)

  useEffect(() => {
    const syncTab = () => setTab(tabFromHash())
    window.addEventListener('hashchange', syncTab)
    return () => window.removeEventListener('hashchange', syncTab)
  }, [])

  const selectTab = (nextTab: AnalysisTab) => {
    setTab(nextTab)
    window.location.hash = `/analysis?tab=${nextTab}`
  }

  return (
    <>
      <PageHeader
        title={page.title}
        subtitle={page.subtitle}
        action={(
          <span className={styles.syncChip}>
            <Icon name="clock" size={15} />
            {syncLabel}
          </span>
        )}
      />
      <Tabs
        className={styles.pageTabs}
        data-scope="analysis-tabs"
        items={copy.analysisTabs.map(({ key, label }) => ({ key: key as AnalysisTab, label }))}
        value={tab}
        onChange={selectTab}
      />
      {tab === 'monitor' ? (
        <div className={styles.panel} role="tabpanel">
          <MetricMonitorCard />
          <TaskMonitorCard />
        </div>
      ) : (
        <div className={styles.panel} role="tabpanel">
          <WeeklyReportCards />
          <DiagnosisCards />
          <NextActions />
        </div>
      )}
    </>
  )
}
